/* Reuse the theme's Boulevard instance. Never load a second widget or analytics tag. */
(() => {
  if (window.omniFmInstalled) return;
  window.omniFmInstalled = true;
  let opening = false;
  const delay = ms => new Promise(resolve => window.setTimeout(resolve, ms));
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-fm-path]');
    if (!button || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (opening) return;
    const path = button.dataset.fmPath;
    if (!path || !path.startsWith('/cart/menu/')) return;
    const status = button.closest('.omni-fm-booking').querySelector('.omni-fm-status');
    opening = true;
    button.setAttribute('aria-busy', 'true');
    status.hidden = false;
    status.textContent = 'Opening appointment options...';
    try {
      for (let i = 0; i < 40; i++) {
        if (typeof window.blvd?.openBookingWidget === 'function') break;
        await delay(250);
        if (!button.isConnected) return;
      }
      if (typeof window.blvd?.openBookingWidget !== 'function') throw new Error('Booking unavailable');
      // Reuse the service paths already configured in Omni's Boulevard integration.
      await window.blvd.openBookingWidget({ urlParams: {
        locationId: '4f404d0e-4624-4888-a222-e1a83e71d4ba',
        visitType: 'SELF_VISIT', path
      }});
      status.hidden = true;
    } catch (_) {
      status.textContent = 'Booking could not open. Please call ';
      const phone = document.createElement('a');
      phone.href = 'tel:+17203131510';
      phone.textContent = '(720) 313-1510';
      status.append(phone, document.createTextNode(' and our team can help.'));
    } finally {
      opening = false;
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('shopify:block:select', event => {
    const faq = event.target.closest('.omni-fm-faq');
    if (faq) faq.open = true;
  });
})();
